export const isClient = () => {

	if (typeof window !== 'undefined') {
		return true
	}

	return false;
}


// WEBPACK FOOTER //
// ./client/utils.js